import { useContext } from 'react';

import UploadWorker from 'app/workers/UploadWorker';
import useResource from 'app/hooks/useResource';

const useUploadForm = props => {
  const {
    createFileContexts,
    onFileComplete,
    onGroupComplete
  } = props;

  const uploadWorker = useContext(UploadWorker);

  const createResource = async params => {
    // params will be passed to createFileContexts.
    // only the files param is passed to the worker
    const { files } = params;

    // the files can be referenced to create the
    // fileContexts but shouldn't be altered.
    // the worker will need the unaltered file objects
    let fileContexts = await createFileContexts(params);

    let hooks = {
      onFileComplete,
      onGroupComplete
    }

    uploadWorker.startUpload(files, fileContexts, hooks);
  }

  const {
    formIsOpen,
    onFormClose,
    onFormSubmit,
    onAdd,
  } = useResource({
    createResource,
    disableShowOnCreate: true
  });

  return {
    formIsOpen,
    onAdd,
    onFormClose,
    onFormSubmit
  }
}

export default useUploadForm;
